module.exports = __webpack_public_path__ + "static/media/user-inverted.e8a525c5.svg";